import { PawPrint, CalendarDays, Users, UserPlus, Check, ImagePlus, Download, Send, MessageCircle, ArrowRight } from "lucide-react";
import { MockFrame, EmailFrame, EmailButton } from "./MockFrame";

const Field = ({ label, value }) => (
  <div><p className="text-[10px] font-semibold text-slate-500 mb-1">{label}</p><div className="h-8 rounded-lg border border-slate-200 bg-slate-50 px-2.5 flex items-center text-xs text-[#12234A]">{value}</div></div>
);

const PostMock = ({ m }) => (
  <MockFrame testid="mock-post-form" label={m.form_title}>
    <div className="grid grid-cols-2 gap-2.5">
      <Field label={m.f_species} value={m.species} /><Field label={m.f_breed} value={m.breed} />
      <Field label={m.f_date} value={m.date} /><Field label={m.f_count} value={m.count} />
      <div className="col-span-2"><Field label={m.f_price} value={m.price} /></div>
    </div>
    <div className="flex items-center justify-between mt-3">
      <span className="flex items-center gap-2 text-xs text-slate-600"><span className="h-4 w-7 rounded-full bg-[#F5551E] relative"><span className="absolute right-0.5 top-0.5 h-3 w-3 rounded-full bg-white" /></span>{m.f_wl}</span>
      <span className="rounded-lg bg-[#F5551E] text-white text-xs font-bold px-3 py-1.5">{m.f_save}</span>
    </div>
  </MockFrame>
);

export const MiniCard = ({ m, arrived, joined }) => (
  <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden w-full">
    <div className="relative h-24 bg-cover bg-center" style={{ backgroundImage: `url(${m.pics[arrived ? 2 : 1]})` }}>
      <span className={`absolute top-2 left-2 text-[9px] font-bold uppercase px-2 py-0.5 rounded-full text-white ${arrived ? "bg-emerald-600" : "bg-[#12234A]"}`}>{arrived ? m.card_arrived : m.card_badge}</span>
      {!arrived && <span className="absolute bottom-2 left-2 text-[10px] font-bold px-2 py-1 rounded-full bg-[#F5551E] text-white inline-flex items-center gap-1"><CalendarDays size={10} /> {m.card_count}</span>}
    </div>
    <div className="p-3">
      <p className="text-[9px] font-bold uppercase tracking-wider text-[#F5551E]">{m.card_kind}</p>
      <p className="font-display font-bold text-sm text-[#12234A]">{m.card_title}</p>
      <p className="text-[10px] text-slate-500 mt-1 flex items-center gap-1"><Users size={10} /> {m.card_wl}</p>
      <div className={`mt-2 h-8 rounded-lg text-[11px] font-semibold inline-flex w-full items-center justify-center gap-1 ${joined ? "border-2 border-emerald-500 bg-emerald-50 text-emerald-700" : "bg-[#F5551E] text-white"}`}>
        {joined ? <><Check size={12} /> {m.card_on}</> : <><UserPlus size={12} /> {m.card_join}</>}
      </div>
    </div>
  </div>
);

const AlertMock = ({ m }) => (
  <div className="grid sm:grid-cols-[150px_1fr] gap-3 items-start">
    <MiniCard m={m} />
    <EmailFrame m={m} subject={m.e_alert_subj} testid="mock-alert-email">
      <p className="text-xs font-semibold text-[#12234A]">{m.e_hi}</p>
      <p className="text-xs text-slate-600 mt-1">{m.e_alert_body}</p>
      <EmailButton>{m.e_alert_btn}</EmailButton>
    </EmailFrame>
  </div>
);

const JoinMock = ({ m }) => (
  <div className="grid sm:grid-cols-[150px_1fr] gap-3 items-start">
    <MiniCard m={m} joined />
    <EmailFrame m={m} subject={m.e_join_subj} testid="mock-join-email">
      <p className="text-xs text-slate-600">{m.e_join_body}</p>
      <div className="mt-2 rounded-lg bg-slate-50 p-2 space-y-0.5">{m.e_join_rows.map(([k, v]) => <p key={k} className="text-[11px]"><span className="text-slate-400 w-20 inline-block">{k}</span><strong className="text-[#12234A]">{v}</strong></p>)}</div>
      <EmailButton>{m.e_join_btn}</EmailButton>
    </EmailFrame>
  </div>
);

const STATUS_CLS = ["bg-emerald-100 text-emerald-700", "bg-sky-100 text-sky-700", "bg-sky-100 text-sky-700", "bg-slate-100 text-slate-600", "bg-[#FFF4F0] text-[#F5551E]"];
const ManageMock = ({ m }) => (
  <MockFrame testid="mock-waitlist-table" label={m.wl_title}>
    <table className="w-full text-[11px]">
      <thead><tr className="text-left text-slate-400">{m.wl_cols.map((c) => <th key={c} className="pb-1.5 font-semibold">{c}</th>)}</tr></thead>
      <tbody>{m.wl_rows.map((r, i) => (
        <tr key={r[0]} className="border-t border-slate-100"><td className="py-1.5 font-bold text-[#12234A]">{r[0]}</td><td>{r[1]}</td><td className="text-slate-500">{r[2]}</td>
          <td><span className={`px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${STATUS_CLS[i]}`}>{r[3]}</span></td></tr>))}</tbody>
    </table>
    <div className="flex gap-2 mt-3">
      <span className="rounded-lg bg-[#12234A] text-white text-[11px] font-semibold px-3 py-1.5 inline-flex items-center gap-1"><Send size={11} /> {m.wl_msg}</span>
      <span className="rounded-lg border border-slate-200 text-slate-600 text-[11px] font-semibold px-3 py-1.5 inline-flex items-center gap-1"><Download size={11} /> {m.wl_csv}</span>
    </div>
  </MockFrame>
);

const InboxBubble = ({ m, text, note, photos }) => (
  <div className="flex gap-2.5">
    <span className="shrink-0 h-8 w-8 rounded-full bg-[#FFF4F0] text-[#F5551E] flex items-center justify-center"><PawPrint size={15} /></span>
    <div className="rounded-2xl rounded-tl-sm bg-slate-50 border border-slate-100 p-3 text-xs text-[#12234A] flex-1">
      <p className="font-bold">{m.in_from}</p><p className="text-slate-400 text-[10px]">{m.in_prefix}</p>
      {photos && <div className="grid grid-cols-2 gap-1 mt-2">{m.pics.slice(0, 2).map((p) => <img key={p} src={p} alt="" className="h-16 w-full object-cover rounded-md" />)}</div>}
      <p className="mt-1.5">{text}</p>{note && <p className="mt-1.5 text-slate-600">{note}</p>}
    </div>
  </div>
);

const DateMock = ({ m }) => (
  <MockFrame testid="mock-date-inbox" label={m.in_label}><InboxBubble m={m} text={m.in_date} note={m.in_note} /></MockFrame>
);

const ArriveMock = ({ m }) => (
  <div className="space-y-3">
    <div className="flex items-center gap-2">
      <div className="flex-1"><p className="text-[10px] font-bold uppercase text-slate-400 mb-1">{m.arr_before}</p><MiniCard m={m} joined /></div>
      <ArrowRight className="text-[#F5551E] shrink-0" size={20} />
      <div className="flex-1"><p className="text-[10px] font-bold uppercase text-slate-400 mb-1">{m.arr_after}</p><MiniCard m={m} arrived joined /></div>
    </div>
    <MockFrame testid="mock-arrival-inbox" label={m.in_label}><InboxBubble m={m} text={m.arr_msg} /></MockFrame>
  </div>
);

const PhotosMock = ({ m }) => (
  <MockFrame testid="mock-photo-update" label={m.up_title}>
    <div className="grid grid-cols-4 gap-1.5">{m.pics.map((p) => <img key={p} src={p} alt="" className="h-14 w-full object-cover rounded-lg" />)}</div>
    <p className="text-[10px] text-slate-400 mt-1 flex items-center gap-1"><ImagePlus size={11} /> {m.up_photos}</p>
    <div className="mt-2 rounded-lg border border-slate-200 bg-slate-50 p-2 text-xs text-[#12234A]">{m.up_text}</div>
    <div className="flex items-center justify-between mt-3 gap-2">
      <span className="flex items-center gap-1.5 text-[11px] text-slate-700"><span className="h-4 w-4 rounded bg-[#F5551E] text-white flex items-center justify-center"><Check size={11} /></span>{m.up_tick}</span>
      <span className="rounded-lg bg-[#F5551E] text-white text-[11px] font-bold px-3 py-1.5 shrink-0">{m.up_btn}</span>
    </div>
  </MockFrame>
);

const EmailMock = ({ m }) => (
  <div className="grid sm:grid-cols-2 gap-3 items-start">
    <EmailFrame m={m} subject={m.pe_subj} testid="mock-photo-email">
      <p className="text-xs font-semibold text-[#12234A]">{m.e_hi}</p>
      <p className="text-[11px] text-slate-600 mt-1">{m.pe_body}</p>
      <div className="grid grid-cols-2 gap-1 mt-2">{m.pics.map((p) => <img key={p} src={p} alt="" className="h-16 w-full object-cover rounded-md" />)}</div>
      <div className="mt-2 border-l-4 border-purple-600 bg-slate-50 rounded-md p-2 text-[11px] text-[#12234A]">{m.up_text}</div>
      <EmailButton>{m.pe_btn}</EmailButton>
      <p className="text-[9px] text-slate-400">{m.pe_foot}</p>
    </EmailFrame>
    <MockFrame testid="mock-photo-inbox" label={m.in_label}>
      <InboxBubble m={m} text={m.up_text} photos />
      <p className="mt-3 text-[10px] text-slate-400 flex items-center gap-1"><MessageCircle size={11} /> {m.pe_btn}</p>
    </MockFrame>
  </div>
);

export const JOURNEY_MOCKS = { post: PostMock, alert: AlertMock, join: JoinMock, manage: ManageMock, date: DateMock, arrive: ArriveMock, photos: PhotosMock, email: EmailMock };
